export function fixDomainForBI(url: string) {
  try {
    const urlObj = new URL(url);
    urlObj.hostname = urlObj.hostname.replace(/_/g, '.'); // Replace underscores
    return urlObj.toString();
  } catch (e) {
    return 'https://invalid.url';
  }
}
